<template>
  <div>
    <v-fade-transition>
      <v-overlay :value="enabled" absolute color="white" class="text-center" :opacity="opacity ? opacity : 1">
        <v-progress-circular color="primary" :indeterminate="!progress" :value="progress" :width="3">
        </v-progress-circular>
        <div class="mt-4 pr-8 pl-8 text--primary" v-if="text" v-html="text"></div>
      </v-overlay>
    </v-fade-transition>
  </div>
</template>

<script>
export default {
  name: 'ALoader',
  props: ['enabled', 'text', 'progress', 'opacity']
}
</script>

<style scoped>

</style>